import { Controller } from '@hotwired/stimulus'
import { Turbo } from '@hotwired/turbo-rails'

export default class extends Controller {
  static targets = ['input']
  static values = { url: String }

  apply() {
    const giftCardCode = this.inputTarget.value
    if (!giftCardCode) return

    const formData = new FormData()
    formData.append('gift_card_code', giftCardCode)

    // Also collect ticket quantities (needed by controller to rebuild order)
    document.querySelectorAll('[name^="ticket_quantities["]').forEach((select) => {
      formData.append(select.name, select.value)
    })

    this.appendTip(formData)
    this.appendScheduleId(formData)

    const csrfToken = document.querySelector('meta[name="csrf-token"]').content

    fetch(this.urlValue, {
      method: 'POST',
      headers: {
        'X-CSRF-Token': csrfToken,
        Accept: 'text/vnd.turbo-stream.html',
      },
      body: formData,
    })
      .then((response) => response.text())
      .then((html) => {
        Turbo.renderStreamMessage(html)
      })
      .catch((error) => {
        console.error('Error applying gift card:', error)
      })
  }

  remove() {
    const formData = new FormData()

    // Collect ticket quantities (needed by controller to rebuild order)
    document.querySelectorAll('[name^="ticket_quantities["]').forEach((select) => {
      formData.append(select.name, select.value)
    })

    this.appendTip(formData)
    this.appendScheduleId(formData)

    const csrfToken = document.querySelector('meta[name="csrf-token"]').content

    fetch(this.urlValue, {
      method: 'DELETE',
      headers: {
        'X-CSRF-Token': csrfToken,
        Accept: 'text/vnd.turbo-stream.html',
      },
      body: formData,
    })
      .then((response) => response.text())
      .then((html) => {
        Turbo.renderStreamMessage(html)
      })
      .catch((error) => {
        console.error('Error removing gift card:', error)
      })
  }

  appendScheduleId(formData) {
    const scheduleIdField = document.querySelector('[name="schedule_id"]')
    if (scheduleIdField) {
      formData.append('schedule_id', scheduleIdField.value)
    }
  }

  appendTip(formData) {
    const checkedTip = document.querySelector('input[name="reservation[tip_percentage]"]:checked')
    if (!checkedTip) return
    formData.append(checkedTip.name, checkedTip.value)
    if (checkedTip.value === 'custom') {
      const tipAmount = document.querySelector('input[name="reservation[tip_amount]"]')
      if (tipAmount) formData.append(tipAmount.name, tipAmount.value)
    }
  }
}
